import React, { useState, useEffect } from 'react';
import ControllerTextInput from '../../SharedComponents/formComponents/baseFormComponents/ControllerTextInput';
import api from '../../../api';
import { authenticate } from '../../../auth/helpers';
import apiPublic from '../../../apiPublic';


const StepThree = ({ data, onChange, onNext, control }) => {
  const [error, setError] = useState('');
  const [generation, setGeneration] = useState(null);
  const [makes, setMakes] = useState(null);
  const [fetchError, setFetchError] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(false);

  useEffect(() => {
    if (data.godina) {
      const fetchGeneration = async () => {
        try {
          const response = await apiPublic.get(`/onboarding/generation/${data.godina}`);
          setGeneration(response.data);
        } catch {
          setFetchError('Greška pri učitavanju generacije.');
        }
      };
      fetchGeneration();
    }
  }, [data.godina]);

  useEffect(() => {
    if (data.marka) {
      const fetchMakes = async () => {
        try {
          const response = await apiPublic.get(`/onboarding/make/${data.marka}`);
          setMakes(response.data);
        } catch {
          setFetchError('Greška pri učitavanju marke.');
        }
      };
      fetchMakes();
    }
  }, [data.marka]);

  const handleChange = (name, value) => {
    onChange({ target: { name, value } });
  };

  const handleNext = async () => {
    const email = data.email || '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      setError('Email je obavezan.');
      return;
    }

    if (!emailRegex.test(email)) {
      setError('Uneta email adresa nije validna.');
      return;
    }

    setError('');

    try {
      const onboardResponse = await apiPublic.post('/onboarding', { email: data.email });
      authenticate({
        data: onboardResponse.data
      });



      setIsEmailSent(true);
    } catch (err) {
      console.error('Onboarding error:', err.response?.data || err.message || err);

      setSubmitError('Greška pri slanju email-a za onboarding. Pokušaj ponovo.');
      return;
    }

    try {
      await api.post('/partrequest/onboard-create', {
        description: data.opis,
        id_car_make: data.marka,
        id_car_model: data.model,
        id_car_generation: data.godina,
        id_car_motor: data.motor,
        vin: data.brojSasije,
        email: data.email,
        additional_description: data.opis,
      });

      onNext();
    } catch (err) {
      setSubmitError('Greška pri slanju zahteva. Pokušaj ponovo.');
      console.error('API greška:', err);
    }
  };

  return (
    <div style={styles.form}>
      <h2 style={styles.title}>Unesi svoj email i očekuj odgovore prodavaca u roku od 24h!</h2>

      <div style={styles.previewBox}>
        <p style={styles.firstLine}>
          {makes ? makes.name : 'N/A'}• {generation ? generation.name : 'N/A'} • {data.brojSasije}
        </p>
        <p style={styles.description}>{data.opis}</p>
      </div>

      <p style={styles.subtitle}>
        Unesi svoju email adresu i 189 prodavaca će videti tvoj zahtev:
      </p>

      <div style={styles.inputGroup}>
        <ControllerTextInput
          name="email"
          control={control}
          defaultValue={data.email}
          placeholder="Tvoja email adresa"
          onChange={(e) => handleChange('email', e.target.value)}
          width={254}
          styleForInput={{
            padding: '12px 16px',
            borderRadius: 6,
            border: '1px solid #787878',
            color: 'white',
            fontSize: '16px',
          }}
        />
        <button onClick={handleNext} style={styles.button}>
          <span style={styles.buttonText}>Oglasi zahtev</span>
        </button>
      </div>

      {error && <p style={styles.error}>{error}</p>}
      {submitError && <p style={styles.submitError}>{submitError}</p>}
    </div>
  );
};

export default StepThree;

const styles = {
  form: {
    margin: '0 auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  title: {
    fontSize: '34px',
    marginBottom: 20,
    lineHeight: '42px',
  },
  previewBox: {
    backgroundColor: 'rgb(243, 244, 246)',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: 20,
    borderRadius: 2,
    textAlign: 'left',
    marginBottom: 20,
    width: 'fit-content',
    display: 'inline-block',
  },
  firstLine: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '20px',
    fontWeight: 600,
    fontStyle: 'normal',
    letterSpacing: '0.15px',
    textAlign: 'left',
    lineHeight: '24px',
  },
  description: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    letterSpacing: '0px',
    textAlign: 'left',
    lineHeight: '24px',
  },
  subtitle: {
    fontSize: '16px',
    color: 'white',
    marginBottom: 12,
    lineHeight: '24px',
  },
  inputGroup: {
    display: 'flex',
    gap: 12,
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  button: {
    padding: '12px 24px',
    backgroundColor: '#d3e205',
    fontWeight: 'bold',
    borderRadius: 6,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: '20px',
    gap: 10,
  },
  buttonText: {
    fontSize: '16px',
  },
  error: {
    color: 'white',
    marginTop: 10
  },
  submitError: {
    color: 'red',
    marginTop: 10
  }
};
